export class LoadingStart {
  public static readonly type = '[Loading] Start';
}
export class LoadingComplete {
  public static readonly type = '[Loading] Complete';
}
